import { httpCreate } from './http';

const http = httpCreate('/srv/service-mch-violation');

export const serviceMchViolation = {
	// 违约记录-列表
	list(params) {
		return http.get(`/list`, { params });
	},
	// 违约记录-标记已读
	read(id) {
		return http.put(`/${id}`);
	},
};
